import { twMerge } from 'tailwind-merge';
import { ContentDto } from '@diritto/common/content/dtos/content.dto';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { Link } from '@/ui-components/common/Link';
import { ContentBadgeGroup } from '@/ui-components/contents/ContentBadgeGroup';
import { BadgeMode } from '@/constants/badge';

export const SectionContentTitleText = ({
  content,
  className,
}: {
  content: ContentDto | ContentPublicRelayDto;
  className?: string;
}) => (
  <Link href={`/contents/${content.id}`} className={twMerge('flex gap-1 items-center w-full', className)}>
    <ContentBadgeGroup content={content} mode={BadgeMode.TEXT} />
    <p className="text-xs font-medium text-black line-clamp-1 overflow-hidden break-all">{content.title}</p>
  </Link>
);
